import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  padding: 12px 24px;
  align-items: center;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;

  border-bottom: 1px solid var(--alias-color-line-normal);
  p {
    white-space: nowrap;
  }
`;

export const MeetingTitle = styled.div`
  display: flex;
  min-width: 280px;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
`;

export const Title = styled.div`
  display: flex;
  height: 24px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`;

export const CreatorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  .label {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;

export const LabelContainer = styled.div<{ minWidth: number; maxWidth: number }>`
  display: flex;
  min-width: ${(props) => props.minWidth}px;
  max-width: ${(props) => props.maxWidth}px;
  align-items: center;
  gap: 8px;
  flex: 1;

  p {
    white-space: nowrap;
  }
`;

export const MeetingRoomDataContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  width: 240px;
`;

export const MeetingRoomTitle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;

  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 154px;
  }
`;
